// extracted by mini-css-extract-plugin
module.exports = {"register-form":"RegisterForm_register-form__3_JjW","register-form__rules":"RegisterForm_register-form__rules__2W0CR"};